import script from "./RouterTabPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterTabPanel.vue?vue&type=script&setup=true&lang=js"

import "./RouterTabPanel.vue?vue&type=style&index=0&id=1a89bb5a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a89bb5a"]])

export default __exports__